module.exports = __webpack_public_path__ + "static/media/gameCakeDecorating.e0466ddd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gameCakeDecorating.png
// module id = 2628
// module chunks = 0